export const props = Object.freeze({
  /**
   * Language of the code in the element's text content: `json`, `html` or `xml`.
   *
   * @type {String}
   * @default "json"
   */
  language: {
    type: String,
    default: "json",
  },
});
